import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dimensions, Platform, ScrollView, View } from "react-native";
import WebView from "react-native-webview";
import { isMobileView } from "../../stack/utils";
import CustomHeader from "../../customHeader/CustomHeader";
import NeedHelpDC from "../NeedHelpDC";
let Share;
// @ts-ignore
import('react-native-share').then(module => {
    Share = module.default;
    // You can now use Share here
}).catch(error => {
    console.error('Error loading Share module:', error);
});
const InterestCalculatorApp = ({ height, shareLinkAction, baseLink, goBackAction, contactUsDetails, showOnlyDownload, triggerAction }) => {
    const containerRef = useRef(null);
    const _isMobile = isMobileView();
    const [iframeHeight, setIFrameHeight] = useState(400);
    const [iframeWidthApp, setIframeWidthApp] = useState(Dimensions.get('window')?.width);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const webViewRef = useRef(null);
    const [showHeader, setShowHeader] = useState(true);
    const [webViewScrollEnabled, setWebViewScrollEnabled] = useState(true);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const handleMessage = (event) => {
        if (event?.nativeEvent?.data === 'MODAL_OPEN') {
            webViewRef?.current?.injectJavaScript("document.body.style.overflow = 'hidden'; true;");
            setWebViewScrollEnabled(false);
            return;
        }
        if (event?.nativeEvent?.data === 'MODAL_CLOSE') {
            webViewRef?.current?.injectJavaScript("document.body.style.overflow = 'auto'; true;");
            setWebViewScrollEnabled(true);
            return;
        }
        if (event?.nativeEvent?.data === 'IC_INIT_PAGE') {
            setShowHeader(false);
            return;
        }
        if (event?.nativeEvent?.data === 'IC_VIEW_PAGE') {
            setTimeout(() => {
                setShowHeader(true);
            }, 750);
            return;
        }
        try {
            const base64Data = event.nativeEvent.data;
            if (base64Data) {
                const shareOptions = {
                    title: 'Share PDF',
                    url: base64Data,
                    type: 'application/pdf',
                };
                Share.open(shareOptions);
            }
        }
        catch (error) {
            console.log('Error', 'Failed to share the PDF', error);
        }
    };
    const handleIframeMessage = (event) => {
        if (event?.data?.data && event?.data?.id === 'getDimensionLeads') {
            setIFrameHeight(event?.data?.data);
        }
        if (event?.data?.data && event?.data?.id === 'handleMessageSendOnFullScheduleClick') {
            const x = event?.data?.data?.position?.x;
            const y = event?.data?.data?.position?.y;
            containerRef?.current?.scrollTo({ x: parseInt(x), y: parseInt(y), animated: true });
        }
        if (event?.data?.id === 'IC_INIT_PAGE') {
            setShowHeader(false);
        }
        if (event?.data?.id === 'IC_VIEW_PAGE') {
            setShowHeader(true);
        }
    };
    useEffect(() => {
        if (Platform.OS === 'web') {
            window.addEventListener('message', handleIframeMessage);
            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('message', handleIframeMessage);
            };
        }
    }, []);
    useEffect(() => {
        if (Platform.OS === 'web') {
            window.addEventListener('message', handleIframeMessage);
            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('message', handleIframeMessage);
            };
        }
    }, [_isMobile]);
    const getIframeHeightMob = () => {
        if (Platform.OS === 'ios' && !showHeader) {
            return height - 60;
        }
        if (Platform.OS === 'ios') {
            return height - 120;
        }
        if (Platform.OS === 'android' && !showHeader) {
            return height - 5;
        }
        return height - 60;
    };
    const renderIframe = () => {
        return (React.createElement(WebView, { ref: webViewRef, source: {
                uri: showOnlyDownload
                    ? `${baseLink}/interest-calculator-iframe?isMobileView=true&showOnlyDownload=true`
                    : `${baseLink}/interest-calculator-iframe?isMobileView=true`
                // uri: showOnlyDownload 
                //     ? `http://172.16.16.7:8080/interest-calculator-iframe?isMobileView=true&showOnlyDownload=true`
                //     : `http://172.16.16.7:8080/interest-calculator-iframe?isMobileView=true`
            }, style: Platform.OS !== 'web' ? {
                width: iframeWidthApp,
                height: getIframeHeightMob()
            } : {
                height: iframeHeight + 20,
            }, onMessage: handleMessage }));
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { goBackId: 'bt_interestCalculator_goBack', needHelpId: 'bt_interestCalculator_needHelp', title: '', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    return (React.createElement(View, { style: {
            height: height
        } },
        showHeader &&
            headerChild,
        Platform.OS === 'ios' &&
            !showHeader &&
            React.createElement(View, { style: {
                    height: 50
                } }),
        React.createElement(ScrollView, { ref: containerRef, style: {
                width: '100%',
                height: Platform.OS === 'web' ? height - 67 : height
            }, contentContainerStyle: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            } }, renderIframe()),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })));
};
export default InterestCalculatorApp;
